/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiExternalUserFromJSON, StreemApiExternalUserToJSON, StreemApiUserFromJSON, StreemApiUserToJSON, } from './';
export function StreemApiGetUserByExternalUserIdResponseFromJSON(json) {
    return StreemApiGetUserByExternalUserIdResponseFromJSONTyped(json, false);
}
export function StreemApiGetUserByExternalUserIdResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalUser': !exists(json, 'external_user') ? undefined : StreemApiExternalUserFromJSON(json['external_user']),
        'user': !exists(json, 'user') ? undefined : StreemApiUserFromJSON(json['user']),
    };
}
export function StreemApiGetUserByExternalUserIdResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'external_user': StreemApiExternalUserToJSON(value.externalUser),
        'user': StreemApiUserToJSON(value.user),
    };
}
//# sourceMappingURL=StreemApiGetUserByExternalUserIdResponse.js.map